import { motion } from "framer-motion";
import { IMG } from "@/components/data";
import { useLang } from "@/i18n";

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section id="esperienza" className="relative bg-ferrari grain text-white overflow-hidden">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 pt-[50px] pb-[50px] md:pt-[82px] md:pb-[82px] relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-white/70">{t.manifesto.label}</span>
            <h2 className="font-display font-extrabold uppercase tracking-tighter text-4xl md:text-6xl mt-4 leading-[0.88]">
              {t.manifesto.title}
            </h2>
            <div className="mt-8 relative h-72 md:h-96 overflow-hidden border border-white/30 rounded-2xl">
              <img src={IMG.founder} alt="Direttore di stabilimento" className="w-full h-full object-cover" />
              <div className="absolute bottom-0 left-0 bg-white text-ink px-4 py-3">
                <div style={{ fontFamily: "'Times New Roman', Times, serif" }} className="text-xl font-bold tracking-tight leading-none">
                  <span className="text-ferrari">PST</span> <span className="text-ink">Pellet</span>
                </div>
                <div className="text-[11px] uppercase tracking-[0.15em] text-ink/60 mt-1">{t.manifesto.founder}</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pl-10">
            {t.manifesto.chapters.map((c, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                data-testid={`manifesto-chapter-${i}`}
                className="grid grid-cols-12 gap-4 py-8 border-t border-white/25 first:border-t-0 lg:first:border-t"
              >
                <div className="col-span-12 lg:col-span-3 font-display font-extrabold text-6xl md:text-7xl leading-none text-white/85">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="col-span-12 lg:col-span-9">
                  <h3 className="font-display font-bold uppercase tracking-tight text-2xl md:text-3xl">{c.title}</h3>
                  <p className="mt-3 text-white/85 text-base md:text-lg leading-relaxed max-w-2xl">{c.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
